<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <textarea #inputtextarea [rows]="rows" [(ngModel)]="value" [placeholder]="placeholder || ''" [ngClass]="{'form-control': true, invalid: (invalid | async), 'no-resize': noResize}"
    [id]="identifier" [disabled]="disabled" [readonly]="readonly"></textarea>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.TextareaComponent.html